<template>
    <div>
        <a-row>
            <a-col :span="24" style="margin-bottom: 10px;border-bottom: 1px solid #f0f2f5;">
                <a-row type="flex" justify="end">
                    <a-col :span="20" :style="{textAlign: 'left',padding: '10px 0 0 20px'}">
                        <span style="font-size: 1.6em;">站群管理</span>
                    </a-col>
                    <a-col :span="4" :style="{textAlign: 'right', padding: '10px 20px 10px 0'}">
                        <a-button type="primary" @click="editInfo('add')">
                            添加网站
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :style="{padding: '10px 24px 24px 24px'}">
                <a-table
                    :columns="columns"
                    :row-key="record => record.uuid"
                    :data-source="data"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >
                    <!--操作按钮-->
                    <span slot="action" slot-scope="record">
                        <a-popconfirm
                            v-if="data.length"
                            title="确定删除该网站吗?"
                            @confirm="() => deleteWebsite(record.uuid)"
                            ok-text="删除"
                            cancel-text="取消"
                            style="margin-left: 5px;"
                        >
                            <a-button size="small" type="danger">
                                删除
                            </a-button>
                        </a-popconfirm>
                        <a href="javascript:;" @click="editInfo(record.uuid)" style="margin-left: 5px;">编辑</a>
                    </span>


                    <!--展开行-->
                    <a-row slot="expandedRowRender" slot-scope="record" style="margin: 0">

                        <a-col :span="6">
                            <span class="tb-content-title">修改时间:</span>{{ record.modifyTime }}
                        </a-col>
                        <a-col :span="4">
                            <span class="tb-content-title">LOGO:</span>
                            <a-button size="small" type="primary" @click="showModal(record.logo)">
                                图片
                            </a-button>
                        </a-col>
                        <a-col :span="14">
                            <span class="tb-content-title">描述:</span>{{ record.descInfo }}
                        </a-col>
                    </a-row>

                    <template slot="name" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'title', $event)"/>
                    </template>
                    <template slot="company" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'company', $event)"/>
                    </template>
                    <template slot="host" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'host', $event)"/>
                    </template>
                    <template slot="wxCode" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'wxCode', $event)"/>
                    </template>
                    <template slot="phone" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'phone', $event)"/>
                    </template>
                    <template slot="keywords" slot-scope="text, record">
                        <editable-cell :text="text" @change="onCellChange(record.uuid, 'keywords', $event)"/>
                    </template>
                </a-table>
            </a-col>
        </a-row>
        <a-modal v-model="visible" title="LOGO">
            <template slot="footer">
                <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
                    关闭
                </a-button>
            </template>
            <img :src="img" style="width: 100%;"/>
        </a-modal>
    </div>
</template>

<script>
import EditableCell from "@/components/common/EditableCell";



export default {
    name: "Website",
    data() {
        const columns = [
            {
                title: '名称',
                dataIndex: 'title',
                sorter: false,
                scopedSlots: {customRender: 'name'},
            },
            {
                title: '公司',
                dataIndex: 'company',
                sorter: false,
                scopedSlots: {customRender: 'company'},
                // ellipsis: true,
            },
            {
                title: '域名',
                dataIndex: 'host',
                sorter: false,
                scopedSlots: {customRender: 'host'},
            },
            {
                title: '模板',
                dataIndex: 'templates',
                sorter: false,
                // width: '20%',
            },
            {
                title: '微信',
                dataIndex: 'wxCode',
                sorter: false,
                scopedSlots: {customRender: 'wxCode'},
            },
            {
                title: '手机',
                dataIndex: 'phone',
                sorter: false,
                scopedSlots: {customRender: 'phone'},
                width: '160px',
            },
            {
                title: '关键词',
                dataIndex: 'keywords',
                sorter: false,
                scopedSlots: {customRender: 'keywords'},
                width: '250px'
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                sorter: true,
                width: '180px',
                align: 'center',
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'x',
                width: '120px',
                align: 'center',
                scopedSlots: {
                    customRender: 'action'
                }
            },
        ];
        return {
            data: [],
            pagination: {},
            loading: false,
            columns,
            templates: [],
            img: '',
            visible: false
        };
    },
    components: {
        EditableCell,
    },
    methods: {
        editInfo(uuid) {
            this.$router.push({
                name: "websiteAdd",
                params: {
                    website: uuid
                }
            });
        },
        showModal(img) {
            this.img = img;
            this.visible = true;
        },
        handleOk() {
            this.visible = false;
        },
        handleTableChange(pagination, filters, sorter) {
            const pager = {...this.pagination};
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                size: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
            });
        },
        onCellChange(key, dataIndex, value) {
            const dataSource = [...this.data];
            const target = dataSource.find(item => item.uuid === key);
            if (target) {
                target[dataIndex] = value;
                let that = this;
                let params = {
                    uuid: key,
                    [dataIndex]: value,
                };
                this.updateData(params).then(function () {
                    that.data = dataSource;
                });
            }
        },
        updateData: function (params = {}) {
            let that = this;
            return new Promise((resolve, reject) => {
                this.$ajax.post(this.$host+"/admin/website/edit", params)
                    .then(function (res) {
                        const result = res.data;
                        that.$message.info(result.msg);
                        if (result.code === 200) {
                            resolve(result.msg);
                        } else {
                            reject(result.msg);
                        }
                    }).catch(function (err) {
                    reject(err);
                });
            });
        },
        fetch: function (params = {}) {
            this.loading = true
            let that = this
            this.$ajax.get(this.$host+"/admin/website/list", {
                params: {
                    size: 10,
                    ...params,
                }
            }).then(function (res) {
                that.loading = false
                const result = res.data;
                if (result.code === 200 && result.data.list.length > 0) {
                    const pagination = {...that.pagination};
                    pagination.total = result.data.total;
                    for (let i = 0; i < result.data.list.length; i++) {
                        result.data.list[i].templates = that.$templatesMap.get(result.data.list[i].templates);
                    }
                    that.data = result.data.list;
                    that.pagination = pagination;
                }
            }).catch(function (err) {
                console.log(err)
            });
        },
        deleteWebsite: function (website) {
            let params = new FormData();
            params.set("website",website);
            let that = this;
            this.$ajax.post(this.$host+"/admin/website/delete", params)
                .then(function (res) {
                    const result = res.data;
                    that.$message.info(result.msg);
                    if(result.code===200){
                        that.fetch();
                    }
                }).catch(function (err) {
                console.log(err)
            });
        }
    },
    mounted() {
        this.fetch();
    }
}
</script>

<style scoped>
.tb-content-title {
    font-weight: bolder;
    padding-right: 10px;
    font-size: 15px;
}
</style>